import { formatCurrency } from '@/lib/utils';
import type { Transaction } from '@/types/transaction';

/**
 * Summarise outstanding amounts for a set of transactions. Amounts are only summed within a
 * currency: a selection spanning several currencies is reported as one total per currency rather
 * than a single meaningless figure.
 */
export function formatOutstandingByCurrency(transactions: Transaction[], baseCurrency: string): string {
  const totalsByCurrency = new Map<string, number>();

  for (const transaction of transactions) {
    const currency = transaction.currency || baseCurrency;
    const outstanding = transaction.outstandingAmount ?? transaction.amount;
    totalsByCurrency.set(currency, (totalsByCurrency.get(currency) ?? 0) + outstanding);
  }

  return [...totalsByCurrency.entries()].map(([currency, total]) => formatCurrency(total, currency)).join(' + ');
}
